import { render } from "./TestKits.vue?vue&type=template&id=04421f47&scoped=true"
import script from "./TestKits.vue?vue&type=script&lang=js"
export * from "./TestKits.vue?vue&type=script&lang=js"

import "./TestKits.vue?vue&type=style&index=0&id=04421f47&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04421f47"]])

export default __exports__